// 指令
import Vue from 'vue'
// 防重点，使用：在按钮标签添加属性v-preventReClick
Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => { 
    	if (!el.disabled) {
	        el.disabled = true
	        setTimeout(() => {
	          el.disabled = false
	        }, binding.value || 2000)
        }
    })
  }
})